
import React from "react";
import styled from "styled-components";

export const Title = () => {
  const url = `/logo_bus.png`;
  return (
    <SContainer>
      <SImg src={url} alt="" />
      <SName>沼津駅南口バス発車時刻案内</SName>
    </SContainer>
  );
};

const SContainer = styled.div`
  height: 60px;
  display: flex;
  align-items: center; /*上下*/
  justify-content: left; /*左右*/
  margin: 0px;
  padding: 0px;
`;

const SImg = styled.img`
  margin: 0px;
  margin-left: 20px;
  margin-right: 20px;
  height: 60px;
  width: 60px;
`;

const SName = styled.div`
  font-size: 36px;
  color: #003676;
`;
